module.exports = __webpack_public_path__ + "img/week.be5030ca.webp";